import { inject } from '@angular/core';
import { Auth, authState } from '@angular/fire/auth';
import { CanActivateFn, Router } from '@angular/router';
import { map, take } from 'rxjs';
import { ROUTES } from '../../shared/constants';

/**
 * Guard that prevents authenticated users from accessing public auth routes (like login/signup).
 * Redirects to home. Pending invites are handled by LoginService/SignupService via sessionStorage.
 */
export const publicGuard: CanActivateFn = (_route, state) => {
  const router = inject(Router);
  const auth = inject(Auth);

  // Allow action links unconditionally so OOB codes can be processed
  if (state.url.includes('/auth/action') || state.url.includes('/auth/reset-password') || state.url.includes('/auth/verify-email')) {
    return true;
  }

  return authState(auth).pipe(
    take(1),
    map(user => {
      if (!user) return true;
      return router.createUrlTree([ROUTES.HOME]);
    })
  );
};
